module.exports = __webpack_public_path__ + "static/media/zhinengdaifuxitong.3faed88a.jpg";